<div class="file-list">
  @for (file of files(); track file.id) {
    <app-downloadable-file-card [file]="file" />
  }
</div>
